// extracted by mini-css-extract-plugin
export default {"processing":"Processing_processing__tLj7S"};